import React, { Component } from 'react';
import SubItems from './SubItems';
import { getDisplayName } from '../Common/Utilities';

export class MenuItems extends Component {
    constructor(props) {

        super(props);
    }

    componentDidMount() {
        // Any necessary setup can be done here
    }

    render() {
        const { items } = this.props;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h4 className="panel-title">
                        <a
                            className="accordion-toggle non-auth"
                            data-toggle="collapse"
                            href={"#" + items.id}
                        >
                            <i className="material-icons">{items.iconStr}</i>
                            {items.label}
                        </a>
                    </h4>
                </div>
                <div
                    id={items.id}
                    className="panel-collapse collapse"
                    data-parent="#accordion"
                >
                    <div className="panel-body">
                        <table className="table">
                            <tbody>
                                {items.items &&
                                    items.items.map((subItem) => {
                                        let subItemLabel = subItem.label;
                                        if (subItem.id === "VendorPayToMapping") {
                                            const siteDisplayName = getDisplayName('site');
                                            subItemLabel = `Vendor ${siteDisplayName} Mapping`;
                                        }
                                        if (subItem.id === "UserInvoiceStatuses") {
                                            const siteDisplayName = getDisplayName('User Status');
                                            subItemLabel = `${siteDisplayName}`;
                                        }

                                        return (
                                            <SubItems
                                                subItem={{ ...subItem, label: subItemLabel }}
                                                isCurrClass={window.location.pathname === subItem.path}
                                                setClass={this.props.setClass}
                                                updateLeftMenu={this.props.updateLeftMenu}
                                                key={subItem.id}
                                            />
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
